<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal" style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
      <cv-row>
        <cv-column :sm="2" :md="2" :lg="4">
          <data-valida etichetta="Data Fattura"
                       v-model="parametri.dta_fattura"
                       messaggio_non_valido="Data fattura non valida" />
        </cv-column>
        <cv-column :sm="2" :md="2" :lg="4">
          <cv-text-input label="Numero" value="15" style="width: 8em;" />
        </cv-column>
        <cv-column :sm="2" :md="2" :lg="4">
          <data-valida etichetta="Data Registrazione"
                       v-model="parametri.dta_registrazione" readonly
                       messaggio_non_valido="Data di registrazione non valida" />
        </cv-column>
        <cv-column :sm="2" :md="2" :lg="4">
          <data-valida etichetta="Data di Pagamento"
                       v-model="parametri.dta_pagamento"
                       messaggio_non_valido="Data di pagamento non valida" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label="Seleziona un cliente" title="Cliente"
                        :auto-filter="true"
                        @change="cambiamento"
                        v-model="modello"
                        :options="options"></cv-combo-box>
        </cv-column>
      </cv-row>

      <cv-row>
        <!-- griglia delle righe della fattura -->
        <cv-column :sm="0" :md="8" :lg="16">
          <cv-data-table style="margin-top: 1em; margin-bottom: 1em;"
                         :columns="colonne"
                         helper-text="Righe della fattura"
                         :data="righe">
          </cv-data-table>
        </cv-column>

        <cv-column :sm="4" :md="0" :lg="0">
          <cv-structured-list v-for="(riga, indice) in righe" v-bind:key="indice">
            <template slot="items">
              <cv-structured-list-item v-for="(colonna, indice_colonna) in colonne" v-bind:key="indice_colonna">
                <cv-structured-list-data>
                  {{ colonna }}
                </cv-structured-list-data>
                <cv-structured-list-data>
                  {{ riga[indice_colonna] }}
                </cv-structured-list-data>
              </cv-structured-list-item>
            </template>
          </cv-structured-list>
        </cv-column>
      </cv-row>

      <cv-row>
        <cv-column :sm="4" :md="8" :lg="8">
          <cv-text-area
              label="Note"
              value=""></cv-text-area>
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="4">
          <cv-text-input label="Tot. Imponibile" readonly
                         title="Tot. Imponibile" value="€ 200,00" />
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="4">
          <cv-text-input label="Totale" readonly
                         title="Totale" value="€ 220,00" />
        </cv-column>
      </cv-row>

    </cv-grid>
    <hr/>
    <Bottoniera testo_nuovo="Nuova Fattura"
                testo_salva="Salva Fattura"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')"
    />
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";
export default {
  name: "Fatture",
  components: { Bottoniera },
  data: function() {
    return {
      parametri: {
        dta_fattura: "14/08/2020",
        dta_registrazione: "15/08/2020",
        dta_pagamento: "16/08/2020"
      },
      // Come primo valore, mettici il nome del cliente e non il valore dell'id
      modello: "Paolo Verdi s.r.l",
      options: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "1",
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "2",
        }
      ],
      colonne: [
        "Descrizione",
        "UM",
        "Quantità",
        "Tariffa",
        "IVA",
        "Sconto",
        "Imponibile",
        "Totale"
      ],
      righe: [
          [
              "Estrazione bietole + carico",
              "Ettari (HT)",
              "1",
              "€ 200,00",
              "10%",
              "0",
              "€ 200,00",
              "€ 220,00"
          ]
      ]
    }
  },
  methods:  {
    cambiamento: function(evento) {
      console.log(evento);
      console.log(typeof  this.modello);
      console.log(this.modello);
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/carbon';

#main-content {
  background-color: $ui-background;
}
</style>